/**
 * Cocinareporteinterrelacion Archetype
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeCocinareporteinterrelacionCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Cocinareporteinterrelacion => Cocinareporteinterrelacion_hijo respectivamente.
 * @date May 22th, 2025
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date May 22th, 2025
 * @version 1.0
 */

import _ from 'lodash'

const baseController = 'Cocinareporteinterrelacion'

const baseIndex = baseController + '/index'

const archetype = () => {
	return [
		// [hidden|number|price|phone|textarea|positivo|password|email]
		{
			key: 'id',
			type: 'hidden'
		}
	]
};

const captions = [
    {key: 'cliente', sortable: true},
    {key: 'sede', label: 'Sede', sortable: true},
    {key: 'grupo'},
    {key: 'plan', sortable: true},
    {key: 'cantidad', sortable: true},
    {key: 'precio', sortable: true, label: 'Venta'},
    // {key: '_'},
    // {key: 'plan_tipo'},
    // {key: 'presencia_tipo'},
    // {key: 'sede_tipo'},
    // {key: 'codigo'},
    // {key: 'cantidad'},
    // {key: 'notas_alimentarias'}
]

// const estatusFilterSample = {
//         key: 'estatus',
//         required: false, // IF THIS IS TRUE, A DEFAULT OPTION SHOULD BE DEFINED, OTHERWISE THE COMPONENT WILL PICK THE FIRST ITEM IN ROW.
//         options: [
//             'Activo',
//             'Oculto'
//             // { key: 'all', label: 'Todos' },
//         ],
//         default: null,
//     };

const quicktableFilters = () => {
    return [
        // estatusFilterSample
    ]
}

const archetypeCocinareporteinterrelacionCFG = () => {
    return [
        // { key: 'id', type: 'hidden' },
        // { key: 'Cocinareporteinterrelacion_id', type: 'hidden', },
        // { key: 'descriptor', label: 'Description', readonly: true },
    ]
};

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    captions,
    baseIndex,
    archetype, 
    archetypeCocinareporteinterrelacionCFG, 
    quicktableFilters,
    automodalHandler
}